import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { french } from '../../i18n/languages'
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@material-ui/core'

import { ColorPaper, LogoContainer } from '../Atoms'
import { MainPageContainer } from '../Organisms'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(() => ({
    paper: {
        backgroundColor: 'white',
        zIndex: 1,
        width: 1000,
        marginBottom: 50,
        paddingTop: 40,
        paddingBottom: 40,
        '& h4': {
            textAlign: 'center',
            marginBottom: 30,
        },
        '& h5': {
            marginTop: 30,
            marginBottom: 10,
        },
    },
    boldUnderlined: {
        textDecoration: 'underline',
        fontWeight: 'bold',
    },
    bold: {
        fontWeight: 'bold',
    },
    table: {
        marginBottom: 30,
        marginTop: 30,
        border: '1px solid black',
    },
    listStyle: {
        display: 'list-item',
        marginLeft: 40,
    }
}))

const CookiePolicy = () => {
    const classes = useStyles()
    const { i18n } = useTranslation()
    if (i18n.language === french) return (
        <LogoContainer>
            <MainPageContainer>
                <ColorPaper className={classes.paper}>
                    <Typography variant="h4" className={classes.boldUnderlined}>
                        Politique d’utilisation des cookies
                        <br />
                        (https://fednot-prod-kennismodule.appspot.com)
                    </Typography>
                    <Typography variant="p">
                        Un cookie est un petit fichier texte envoyé à votre navigateur et enregistré sur le disque dur de votre
                        terminal (PC, ordinateur portable ou smartphone, …) lorsque vous visitez un site Internet, comme par
                        exemple votre choix de langue.
                    </Typography>
                    <br />
                    <br />
                    <Typography variant="p">
                        En tant que gestionnaire du site Internet https://fednot-prod-kennismodule.appspot.com, l’asbl Fédération Royale du Notariat belge
                        (Fednot) utilise trois types de cookies qui seront détaillés dans un tableau ci-après.
                    </Typography>
                    <Typography variant="h5" className={classes.bold}>
                        1. Cookies techniquement essentiels
                    </Typography>
                    <Typography variant="p">
                        Les cookies essentiels sont nécessaires pour vous permettre de naviguer sur le site Internet et
                        pour permettre aux fonctionnalités techniques de base de fonctionner. Ils permettent, par
                        exemple, aux actions exécutées pendant l’une de vos visites d’être conservées et ce, également
                        quand vous naviguez d’une page à l’autre sur le site Internet.
                        <br />
                        <br />
                        Ces cookies ne peuvent dès lors pas être désactivés.
                    </Typography>
                    <Typography variant="h5" className={classes.bold}>
                        2. Cookies fonctionnels
                    </Typography>
                    <Typography variant="p">
                        Les cookies fonctionnels permettent au site Internet d’enregistrer des informations qui ont déjà
                        été fournies et de vous offrir des fonctionnalités améliorées personnalisées. Ils permettent, par
                        exemple, de retenir la langue de votre choix.
                        <br />
                        <br />
                        Ces cookies ne peuvent dès lors pas être désactivés.
                    </Typography>
                    <Typography variant="h5" className={classes.bold}>
                        3. Cookies analytiques
                    </Typography>
                    <Typography variant="p">
                        Le site https://fednot-prod-kennismodule.appspot.com utilise « Google Analytics » pour des finalités analytiques. Cet outil d&#39;analyse
                        nous permet de quantifier les visites (le trafic) sur le site Internet afin notamment de savoir
                        combien de fois une page déterminée a été lue. Nous utilisons ces informations uniquement pour
                        améliorer le contenu de notre site Internet et la communication qui l’entoure.
                        <br />
                        <br />
                        Ces cookies ne seront placés sur votre terminal que si vous y avez consenti préalablement.
                    </Typography>
                    <Typography variant="h5" className={classes.boldUnderlined}>
                        Liste des cookies
                    </Typography>
                    <Typography variant="p">
                        Le site Internet https://fednot-prod-kennismodule.appspot.com utilise les cookies suivants :
                    </Typography>
                    <TableContainer component={Paper} className={classes.table}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">Nom</TableCell>
                                    <TableCell align="center">Type et origine</TableCell>
                                    <TableCell align="center">Durée de conservation</TableCell>
                                    <TableCell align="center">Contenu</TableCell>
                                    <TableCell align="center">Objectif</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell align="left">_ga et _ga_#</TableCell>
                                    <TableCell align="left">Cookies analytiques</TableCell>
                                    <TableCell align="left">6 mois</TableCell>
                                    <TableCell align="left">true ou false</TableCell>
                                    <TableCell align="left">Ce cookie détermine si https://fednot-prod-kennismodule.appspot.com peut transmettre vos actions et les traiter avec Google Analytics</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align="left">authcookie</TableCell>
                                    <TableCell align="left">Cookies techniquement essentiels</TableCell>
                                    <TableCell align="left">5 heures</TableCell>
                                    <TableCell align="left">Authentication token</TableCell>
                                    <TableCell align="left">Ce cookie est nécessaire pour la connexion</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align="left">i18next et user_language</TableCell>
                                    <TableCell align="left">Cookies fonctionnels</TableCell>
                                    <TableCell align="left">Pendant la session du browser</TableCell>
                                    <TableCell align="left">Langue</TableCell>
                                    <TableCell align="left">Ce cookie garde la trace de la langue préférée</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <Typography variant="p">
                        Si vous configurez votre navigateur pour bloquer tout cookie quelconque, certaines rubriques du site internet ne fonctionneront pas comme il se doit, voire plus du tout.
                    </Typography>
                    <Typography variant="h5" className={classes.boldUnderlined}>
                        Contact
                    </Typography>
                    <Typography variant="p">
                        Si vous avez la moindre question concernant l’utilisation des cookies sur le site Internet https://fednot-prod-kennismodule.appspot.com, vous pouvez prendre contact avec notre délégué à la protection des données:
                    </Typography>
                    <Typography variant="p" className={classes.listStyle}>
                        en envoyant un courriel à info@privanot.be ; ou
                    </Typography>
                    <Typography variant="p" className={classes.listStyle}>
                        en adressant un courrier à Privanot asbl, rue de la Montagne, 30, 1000 Bruxelles.
                    </Typography>
                </ColorPaper>
            </MainPageContainer>
        </LogoContainer>
    )
    else return (
        <LogoContainer>
            <MainPageContainer>
                <ColorPaper className={classes.paper}>
                    <Typography variant="h4" className={classes.boldUnderlined}>
                        Cookiebeleid
                        <br />
                        (https://fednot-prod-kennismodule.appspot.com)
                    </Typography>
                    <Typography variant="p">
                        Cookies zijn kleine bestandjes die naar uw browser verzonden worden en op de harde schijf van uw informaticatoestellen (pc, laptop, smartphone, ...) worden opgeslagen wanneer u een webpagina bezoekt (bijvoorbeeld uw taalkeuze).
                    </Typography>
                    <br />
                    <br />
                    <Typography variant="p">
                        Als beheerder van de website  https://fednot-prod-kennismodule.appspot.com gebruikt de vzw Koninklijke Federatie van het Belgisch Notariaat (Fednot) drie soorten cookies, die in een tabel hieronder gedetailleerd worden weergegeven.
                    </Typography>
                    <Typography variant="h5" className={classes.bold}>
                        1. Technisch essentiële cookies
                    </Typography>
                    <Typography variant="p">
                        Essentiële cookies zijn noodzakelijk om u in staat te stellen op de website te navigeren en om de technische basisfuncties te laten functioneren. Zij maken het bijvoorbeeld mogelijk dat acties die tijdens een van uw bezoeken worden uitgevoerd, worden bewaard, zelfs wanneer u van de ene pagina naar de andere op de website navigeert.
                        <br />
                        <br />
                        Deze cookies kunnen niet worden gedeactiveerd.
                    </Typography>
                    <Typography variant="h5" className={classes.bold}>
                        2. Functionele cookies
                    </Typography>
                    <Typography variant="p">
                        Functionele cookies stellen de website in staat reeds verstrekte informatie op te slaan en u gepersonaliseerde verbeterde functionaliteit aan te bieden. Ze stellen de website bijvoorbeeld in staat de taal van uw keuze te onthouden.
                        <br />
                        <br />
                        Deze cookies kunnen niet worden gedeactiveerd.
                    </Typography>
                    <Typography variant="h5" className={classes.bold}>
                        3. Analytische cookies
                    </Typography>
                    <Typography variant="p">
                        De website https://fednot-prod-kennismodule.appspot.com maakt voor analytische doeleinden gebruik van "Google Analytics". Met dit analyse-instrument kunnen de bezoeken (traffic) aan de website worden gekwantificeerd om onder meer te weten te komen hoe vaak een bepaalde pagina is gelezen. Wij gebruiken deze informatie uitsluitend om de inhoud van onze website en de communicatie daaromheen te verbeteren.
                    </Typography>
                    <br />
                    <br />
                    <Typography variant="p">
                        Deze cookies worden alleen op uw terminal geplaatst als u daarvoor vooraf toestemming hebt gegeven.
                    </Typography>
                    <Typography variant="h5" className={classes.boldUnderlined}>
                        Lijst van cookies
                    </Typography>
                    <Typography variant="p">
                        De website https://fednot-prod-kennismodule.appspot.com maakt gebruikt van volgende cookies:
                    </Typography>
                    <TableContainer component={Paper} className={classes.table}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">Naam</TableCell>
                                    <TableCell align="center">Soort cookie</TableCell>
                                    <TableCell align="center">Duur van bijhouden</TableCell>
                                    <TableCell align="center">Bevat</TableCell>
                                    <TableCell align="center">Doel</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell align="left">_ga en _ga_#</TableCell>
                                    <TableCell align="left">Analytische cookies</TableCell>
                                    <TableCell align="left">6 maanden</TableCell>
                                    <TableCell align="left">true of false</TableCell>
                                    <TableCell align="left">Deze cookie bepaalt of https://fednot-prod-kennismodule.appspot.com jouw acties mag doorsturen en verwerken met Google Analytics</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align="left">authcookie</TableCell>
                                    <TableCell align="left">Technisch essentiële cookies</TableCell>
                                    <TableCell align="left">5 uur</TableCell>
                                    <TableCell align="left">Authentication token</TableCell>
                                    <TableCell align="left">Deze cookie is noodzakelijk om te kunnen inloggen</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align="left">i18next en user_language</TableCell>
                                    <TableCell align="left">Functionele cookies</TableCell>
                                    <TableCell align="left">Tijdens de browser sessie</TableCell>
                                    <TableCell align="left">Taal</TableCell>
                                    <TableCell align="left">Deze cookie houdt de voorkeurstaal bij</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <Typography variant="p">
                        Indien u uw browser zodanig instelt dat bepaalde cookies of alle cookies geblokkeerd worden, is het mogelijk dat sommige delen van de website niet of niet correct werken.
                    </Typography>
                    <Typography variant="h5" className={classes.boldUnderlined}>
                        Contact
                    </Typography>
                    <Typography variant="p">
                        Voor vragen over het cookiegebruik op de website https://fednot-prod-kennismodule.appspot.com, gelieve contact op te nemen met onze data protection officer:
                    </Typography>
                    <Typography variant="p" className={classes.listStyle}>
                        via mail naar info@privanot.be; of
                    </Typography>
                    <Typography variant="p" className={classes.listStyle}>
                        per brief naar Privanot vzw, Bergstraat 30, 1000 Brussel.
                    </Typography>
                </ColorPaper>
            </MainPageContainer>
        </LogoContainer>
    )
}

export default CookiePolicy